/**
 * UI2 Sign in page copy (Pilot English).
 * TODO(translate): move to `translate/components/EmailLogin/signInPage.ts` when i18n is ready.
 */
export const SIGN_IN_PAGE_COPY = {
  headlinePrefix: "Meet your ",
  headlineAccent: "money person",
  subtitle: "Log in or create your account.",
  emailPlaceholder: "Enter your email",
  continueWithEmail: "Continue with Email",
  orContinueWith: "or continue with",
  verifyTitle: "Check your email",
  verifySubtitlePrefix: "We sent a 6-digit code to",
  invalidCode: "Invalid verification code",
} as const;
